import "../../../src/App.css";
import City from "../../components/City/City";
import AddCity from "../../components/AddCity/AddCity";
import FilterCityData from "../../components/FilterCityData/FilterCityData";
import CityList from "../../components/CityList/CityList";
import React, { useState, useEffect } from "react";
import axios from "axios";
import MasterTopButtons from "../../components/MasterTopButtons/MasterTopButtons";

import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import PaginationLink from "../../components/Pagination/Pagination";
import Wrapper from "../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

function CityMaster() {
  const [cityDetailResponse, setcityDetailResponse] = useState(null);
  const [openProfile, setOpenProfile] = useState(false);
  const [openAddProfile, setOpenAddProfile] = useState(false);
  const [filterCityData, setFilterCityData] = useState(false);
  const [selectedCityId, setSelectedCityId] = useState(); 
  const [loading, setLoading] = useState(false);

  const title = "Add City";
  const heading = "City List";
  const baseAPI = process.env.REACT_APP_API_URL;

  function tokenStorage(){
    setLoading(true);
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(
          `${baseAPI}adminget/GETCity?cityID=0&stateID=0`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          //console.log(response.data.data);
          setcityDetailResponse(response.data.data || []);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        })
        .finally(() => {
          setLoading(false); // Set loading to false when data is fetched
        });
    }
  }
  useEffect(() => {
    tokenStorage();
  }, []);

  //console.log(cityDetailResponse);
  const GetId = (param) => {   
    setSelectedCityId(param);
    
  };


  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />
        <div
          className="container-fluid"
          style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>
              <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                   City Master| <HomeOutlinedIcon />{" "}
                  <span style={{ fontSize: "20px" }}>&gt; Master</span>
                </h1>
              </div>
              <div style={{ width: "8rem" }}>
                <select className="form-control" name="country">
                  <option value="0">INDIA </option>
                  <option value="1">DUBAI </option>
                </select>
              </div>
            </div>
            <div>
              <Wrapper className="ViewLeadDetails">
                <MasterTopButtons
                  title={title}
                  heading={heading}
                  setOpenAddProfile={setOpenAddProfile}
                  openAddProfile={openAddProfile}
                  setOpenProfile = {setOpenProfile}
                  setFilterCityData = {setFilterCityData}
                  filterCityData = {filterCityData}
                />
                {openAddProfile ? <AddCity tokenStorage = {tokenStorage} openAddProfile = {openAddProfile} setOpenAddProfile = {setOpenAddProfile} setFilterCityData = {setFilterCityData}/> : null}
                {openProfile ? <City tokenStorage = {tokenStorage} openProfile = {openProfile} setOpenProfile = {setOpenProfile} selectedCityId={selectedCityId} /> : null}
                {filterCityData? <FilterCityData tokenStorage={tokenStorage} setcityDetailResponse = {setcityDetailResponse} cityDetailResponse = {cityDetailResponse} setFilterCityData = {setFilterCityData} filterCityData = {filterCityData}/> : null}
                <CityList
                  cityDetailResponse={cityDetailResponse}
                  setOpenProfile={setOpenProfile}
                  openProfile={openProfile}
                  GetId={(param) => GetId(param)}                  
                  setOpenAddProfile = {setOpenAddProfile}
                  setFilterCityData = {setFilterCityData}
                  loading = {loading}
                />
                
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CityMaster;
